import { backendServices } from 'common';

type Schedule = backendServices.ViewModels.SIMDocumentTypeScheduleViewModel;

/**
 * The schedule row that governs a `DocumentClass` post-signup. A buyer can have
 * several rows per class, so step visibility, `AttachmentOption`, `Id` and
 * `Description` all resolve through here to stay on the same row.
 */
export function findScheduleForClass(schedules: Schedule[], documentClass: number): Schedule | undefined {
    return schedules.find((schedule) => schedule.DocumentClass === documentClass);
}
